import axios from 'axios';
import { getExpressAPIHost } from '../../../../utils';

const CHUNK_SIZE = 250;

const abortError = () => Object.assign(new Error('Aborted'), { name: 'AbortError' });

const createDeliveryDocumentsDownload = async (ids, layout = [], { signal } = {}) => {
    const base = `${getExpressAPIHost()}/delivery-documents/raw-milk/selections`;
    const source = axios.CancelToken.source();
    signal?.addEventListener('abort', () => source.cancel(), { once: true });
    const post = (url, body) => axios.post(url, body, { cancelToken: source.token });
    try {
        if (signal?.aborted) throw abortError();
        const { selection } = (await post(base, { layout })).data;
        const chunks = Array.from({ length: Math.ceil(ids.length / CHUNK_SIZE) }, (_, i) => ids.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE));
        await chunks.reduce((previous, chunk) => previous.then(() => post(`${base}/${selection}/ids`, { ids: chunk })), Promise.resolve());
        return (await post(`${base}/${selection}/download`)).data;
    } catch (err) {
        if (axios.isCancel(err) || err.name === 'AbortError') throw abortError();
        throw new Error(err.response?.data?.message ?? 'Unable to start the download. Please try again.');
    }
};

export default createDeliveryDocumentsDownload;
